import React, { useState, useContext, useEffect } from 'react';
import { Row, Col, Checkbox } from 'antd';
import { Field } from '../metadata/Field';
import { FormContext } from '../metadata/MDForm';
import { GlobalStateContext } from '../../context/GlobalStateProvider';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import {TooltipHint} from '../metadata/TooltipHint';

export const CheckToggle = ({ attr, label, updateAppOnChange, hintText, ...props }) => {
  const formContext = useContext(FormContext);
  const { isTablet, isMobile, isDesktop } = useContext(GlobalStateContext);
  const [selectedValue, setSelectedValue] = useState(false);
  const actions = useContext(ApplicationActionsContext);

  const { setValueByAttr, getValueByAttr } = formContext;

  useEffect(() => {
    const previousValue = getValueByAttr(attr);
    setValueByAttr(attr, previousValue === 'Yes');
    setSelectedValue(previousValue === 'Yes');
  }, []);

  const handleToggle = e => {
    const value = e.target.checked;
    setValueByAttr(attr, value);
    setSelectedValue(value);
    if (updateAppOnChange === true) {
      actions.saveApplication();
    }
  };

  return (
    <div
        style={{ padding: !isDesktop ? '30px 0px 0px 16px' :'' }}
    >
      <Row>
        <Col span={isDesktop? 9 : 12}>
          <p style={{ fontWeight: 'bold' }}>{label}
            {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
          </p>
        </Col>
        <Col span= {isDesktop? 9 : 12}
          style={{
            display: 'flex',
            justifyContent: isMobile? 'flex-start' : 'flex-end',
            alignContent: 'right'
          }}
        >
          <div style={{width:isTablet? 176: 158, display: 'flex', justifyContent: 'flex-start'}}>
            <Checkbox checked={selectedValue}
                      onChange={handleToggle}
                      aria-label="Multi policy discount check" />
          </div>
        </Col>
        <Col span={isDesktop? 6 : 0}/>
      </Row>
      {selectedValue === true && props.toggleAttr !== null ? (
        <div>
          <Row style={{paddingTop: '24px'}}>
            <Col span={1}/>
            <Col span={isDesktop? 8 : 11} >
              <p style={{ fontWeight: 'bold'}}>
                {label === 'Multi Policy Discount' ? 'Related Policy Number': ''}
              </p>
            </Col>
            <Col span={isDesktop? 9 : 12}>
              <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                  <Field attr={props.toggleAttr}/>
              </div>
            </Col>
          </Row>
        </div>
      ) : null}
    </div>
  );
};
